<template>
  <div
    class="w-full flex flex-col items-center alpha-top p-4 gap-2 border-4 border-green-600 rounded-lg font-inter"
  >
    <div class="flex flex-row items-center gap-1">
      <font-awesome-icon
        class="text-2xl text-green-600"
        icon="fa-solid fa-check-circle"
      />
      <span class="text-2xl font-bold text-green-600">Successful Upgrade</span>
    </div>

    <slot>
      <p class="text-lg text-center">
        You now have full access to
        <span class="font-semibold">{{ currentSite.name }}</span>
        .
      </p>
      <p class="text-center">Enjoy your membership!</p>
    </slot>

    <UButton
      color="green"
      variant="outline"
      class="text-lg mt-4"
      @click="$emit('close')"
    >
      Continue
    </UButton>
  </div>
</template>

<script setup>
  const currentSite = inject("currentSite")
</script>
